<template>
  <div class="card">
    <div class="card-body">
      <b-form @submit.prevent>
        <b-row>
          <!-- Полезные ссылки -->
          <b-col md="6">
            <b-form-group label="Полезные ссылки">
              <div
                v-for="(link, index) in useful_links"
                :key="'links' + index"
                class="links"
              >
                <svg
                  width="16"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="minus"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  class="svg-inline--fa fa-minus fa-w-14"
                  @click="removeUseful(index)"
                >
                  <path
                    d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                  />
                </svg>

                <b-form-input
                  v-model="link.text"
                  class="links__input"
                  placeholder="Название"
                />

                <b-form-input
                  v-model="link.url"
                  class="links__input"
                  placeholder="Адрес"
                />
              </div>

              <b-button
                variant="primary"
                class="mr-1"
                @click="addUseful"
              >
                Добавить ссылку
              </b-button>
            </b-form-group>
          </b-col>

          <!-- Социальные сети -->
          <b-col md="6">
            <b-form-group label="Социальные сети">
              <div
                v-for="(social, index) in socials"
                :key="'social' + index"
                class="links"
              >
                <svg
                  width="16"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="minus"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  class="svg-inline--fa fa-minus fa-w-14"
                  @click="removeSocial(index)"
                >
                  <path
                    d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                  />
                </svg>

                <b-form-input
                  v-model="social.url"
                  placeholder="Введите ссылку в формате http/https"
                  class="links__input"
                />

                <b-form-input
                  v-model="social.code"
                  placeholder="Введите название соц. сети"
                  class="links__input"
                />
              </div>

              <b-button
                variant="primary"
                class="mr-1"
                @click="addSocial"
              >
                Добавить ссылку
              </b-button>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </div>
</template>

<script>
import {
  BButton,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
} from 'bootstrap-vue'

export default {
  name: 'UsefullLinksSection',

  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
  },

  props: {
    useful_links: Array,
    socials: Array,
  },

  methods: {
    addUseful() {
      this.useful_links.push({ text: '', url: '' })
    },
    removeUseful(i) {
      this.useful_links.splice(i, 1)
    },
    addSocial() {
      this.socials.push({ code: null, url: null })
    },
    removeSocial(i) {
      this.socials.splice(i, 1)
    },
  },
}
</script>
<style scoped lang="scss">
.links {
  display: flex;
  align-items: center;

  svg {
    transition: 0.3s;

    &:hover {
      cursor: pointer;
      transform: scale(1.3);
    }
  }

  &__input {
    margin: 10px 0;

    &:nth-child(2) {
      margin: 10px 10px;
    }
  }
}

.fa-minus path {
  fill: #b4b7bd;
}
</style>
